import "./header.css";

import React from "react";
import { Link, NavLink, useLocation } from "react-router-dom";

import { NAV_LINKS, ROUTES } from "../../data/content";

//Top menu link. "Our Services" is also active on each service page
const isLinkActive = (link, pathname) => {
  if (link.path === ROUTES.HOME) {
    return pathname === ROUTES.HOME;
  }
  if (link.path === ROUTES.BLOG) {
    return pathname.startsWith(ROUTES.BLOG) || pathname.startsWith(`${ROUTES.POST}/`);
  }
  return pathname.startsWith(link.path) || (link.children || []).some((child) => pathname.startsWith(child.path));
};

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);
  const { pathname } = useLocation();
  //Close the mobile menu after navigating
  React.useEffect(() => {
    setIsMenuOpen(false);
  }, [pathname]);

  //Close the mobile menu with Escape
  React.useEffect(() => {
    if (!isMenuOpen) {
      return undefined;
    }
    const onKeyDown = (e) => {
      if (e.key === "Escape") {
        setIsMenuOpen(false);
      }
    };
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [isMenuOpen]);

  return (
    <header className={`site-header ${isMenuOpen ? "is-menu-open" : ""}`}>
      <div className={"site-header-inner container"}>
        <Link
          to={ROUTES.HOME}
          className={"site-logos"}
          aria-label={"about U Financial Advisors - Discovery. Home"}
        >
          <img
            src={"/images/logo-discovery.png"}
            alt={""}
            className={"site-logo-discovery"}
            width={656}
            height={242}
          />
          <img
            src={"/images/logo-aboutu.png"}
            alt={""}
            className={"site-logo-aboutu"}
            width={515}
            height={204}
          />
        </Link>

        <button
          type={"button"}
          className={"menu-toggle"}
          aria-expanded={isMenuOpen}
          aria-controls={"site-nav"}
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          <span className={"visually-hidden"}>{isMenuOpen ? "Close menu" : "Open menu"}</span>
          <span
            className={"menu-toggle-icon"}
            aria-hidden={"true"}
          />
        </button>

        <nav
          id={"site-nav"}
          className={"site-nav"}
          aria-label={"Main"}
        >
          <ul className={"site-nav-list"}>
            {NAV_LINKS.map((link) => {
              const isActive = isLinkActive(link, pathname);
              return (
                <li
                  key={link.path}
                  className={`site-nav-item ${link.children ? "has-children" : ""}`}
                >
                  <Link
                    to={link.path}
                    className={`site-nav-link ${isActive ? "is-active" : ""}`}
                    aria-current={pathname === link.path ? "page" : undefined}
                  >
                    {link.label}
                    {link.children ? (
                      <svg
                        className={"site-nav-caret"}
                        viewBox={"0 0 10 6"}
                        aria-hidden={"true"}
                      >
                        <path d={"M1 1l4 4 4-4"} />
                      </svg>
                    ) : null}
                  </Link>
                  {link.children ? (
                    <ul className={"site-subnav"}>
                      {link.children.map((child) => (
                        <li key={child.path}>
                          <NavLink
                            to={child.path}
                            className={({ isActive: isChildActive }) => `site-subnav-link ${isChildActive ? "is-active" : ""}`}
                          >
                            {child.menuName || child.name}
                          </NavLink>
                        </li>
                      ))}
                    </ul>
                  ) : null}
                </li>
              );
            })}
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;
